import CloseIcon from "@/assets/icons/modal-close.svg";
import {
  safeLocalStorageGetItem,
  safeLocalStorageSetItem,
} from "@/util/safeLocalStorage";
import { useEffect, useState } from "react";
import styles from "./index.module.css";
import bg from "./onboarding-bg.jpg";

export function OnBoardingCard() {
  const [isClosed, setIsClosed] = useState(true);
  const handleClose = () => {
    safeLocalStorageSetItem("onboarding-closed", "true");
    setIsClosed(true);
  };

  useEffect(() => {
    const isClosedStatus = safeLocalStorageGetItem("onboarding-closed");
    setIsClosed(isClosedStatus === "true");
  }, []);

  if (isClosed) {
    return null;
  }

  return (
    <div
      className={styles.wrapper}
      style={{ backgroundImage: `url(${bg.src})` }}
    >
      <CloseIcon
        className="absolute top-5 right-5 w-4 h-4 text-[#98A2B3]!"
        onClick={handleClose}
      />
      <div className={styles.title}>🔥 VidMuse: Turn Beats into Vision</div>
      <div className={styles.description}>
        From inspiration to final cut, let&apos;s sync visuals to your sound.
      </div>
      <div className={styles.title}>🚀 How to create in 3 simple steps:</div>
      <div className={styles.description}>
        <ol>
          <li>
            <strong>Drop the Beat</strong>
            <p>
              Upload audio or paste a Suno/YouTube link. I&apos;ll auto-analyze
              the BPM, key, and mood.
            </p>
          </li>
          <li className="mt-2">
            <strong>Pick the Vibe</strong>
            <p>
              Choose a style reference—Cyberpunk, Y2K, 90s Anime, or Wes
              Anderson style.
            </p>
          </li>
          <li className="mt-2">
            <strong>Direct the Cut</strong>
            <p>
              Click to edit images/videos on the canvas, or chat to refine the
              details.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
}
